export default "__VITE_ASSET__5fe2dfd7__"